import React from 'react';

interface StepCadastroFinalizadoProps {
    linkAndroid?: string;
    linkIos?: string;
}

const styles = {
    formTitle: {
        fontSize: '24px',
        fontWeight: '600',
        marginBottom: '16px',
        color: '#374151'
    },
    reviewContainer: {
        backgroundColor: '#f9fafb',
        padding: '16px',
        borderRadius: '8px'
    },
    badges: {
        display: 'flex',
        flexWrap: 'wrap' as const,
        alignItems: 'center',
        gap: '16px',
        marginTop: '16px'
    },
    badge: {
        display: 'block',
        height: '48px'
    }
};

const StepCadastroFinalizado = ({linkAndroid, linkIos}: StepCadastroFinalizadoProps) => (
    <div>
        <h3 style={styles.formTitle}>Parabéns</h3>
        <div style={styles.reviewContainer}>
            Você concluiu o cadastro do seu estabelecimento. Baixe o app e finalize a ativação do restaurante.
        </div>
        <div style={styles.badges}>
            {linkAndroid &&
                <a href={linkAndroid} target="_blank" rel="noopener noreferrer">
                    <img src={`${process.env.PUBLIC_URL}/badges/google-play-pt-br.png`}
                         alt="Disponível no Google Play"
                         style={styles.badge}/>
                </a>
            }
            {linkIos &&
                <a href={linkIos} target="_blank" rel="noopener noreferrer">
                    <img src={`${process.env.PUBLIC_URL}/badges/app-store-pt-br.png`}
                         alt="Baixar na App Store"
                         style={styles.badge}/>
                </a>
            }
        </div>
    </div>
);

export default StepCadastroFinalizado;
